import textServices from 'services/text-services'
import { dlTrackEvent } from 'components/dataLayer/dataLayer'
import { F1_CAMPAIGN_CLOSED } from '../constants'

interface IntroSectionProps {
  onCtaClick: () => void
  /** Gallery phase only: outline CTA under the main one (Figma 5417:10159) */
  showGalleryCta?: boolean
  onGalleryClick?: () => void
}

// Intro block (Figma 5595:12079): green gradient, partially bold copy and
// the main participation CTA.
const IntroSection = ({ onCtaClick, showGalleryCta = false, onGalleryClick }: IntroSectionProps) => {
  return (
    <section className="pitstops__intro">
      <h2 className="pitstops__intro-title">
        {textServices.findByText('pitstops/intro/titleStart', 'Heineken te lleva a la experiencia más ')}
        <strong>{textServices.findByText('pitstops/intro/titleBold1', 'exclusiva')}</strong>
        {textServices.findByText('pitstops/intro/titleMiddle', ' de ')}
        <strong>{textServices.findByText('pitstops/intro/titleBold2', 'F1®')}</strong>
      </h2>
      <p className="pitstops__intro-text">
        <strong>
          {textServices.findByText(
            'pitstops/intro/textBold1',
            'En cada Pit Stop participa por 1 de los 5 pases dobles para Foro Sol'
          )}
        </strong>
        {textServices.findByText(
          'pitstops/intro/textMiddle',
          ' y completa todo el recorrido para llegar a la gran final, donde podrás competir por un '
        )}
        <strong>{textServices.findByText('pitstops/intro/textBold2', 'pase doble al Grandstand.')}</strong>
      </p>
      {/* Campaign closed (Figma 6178:5489): the gallery CTA is the only one left */}
      {!F1_CAMPAIGN_CLOSED && (
        <button
          type="button"
          className="home-v3__button pitstops__cta"
          onClick={() => {
            dlTrackEvent('user_interaction', { action: 'click', element: 'intro :: quiero participar', section: 'pitstops' })
            onCtaClick()
          }}
        >
          {textServices.findByText('pitstops/intro/cta', '¡Quiero participar!')}
        </button>
      )}
      {showGalleryCta && (
        <button
          type="button"
          className={`pitstops__intro-gallery-cta${F1_CAMPAIGN_CLOSED ? ' pitstops__intro-gallery-cta--solo' : ''}`}
          onClick={() => {
            dlTrackEvent('user_interaction', {
              action: 'click',
              element: 'hero :: ver galeria',
              section: 'pitstops'
            })
            onGalleryClick?.()
          }}
        >
          {textServices.findByText('pitstops/hero/galleryCta', 'Ver galería de fotos')}
        </button>
      )}
    </section>
  )
}

export default IntroSection
